import { notifications } from '@mantine/notifications';
import {
  getBankAccountsKey,
  useCreateBankAccount,
} from 'api-hooks/bank-account';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { NavigationProps } from 'types';

import BankAccountForm from './components/form';

export type BankAccountCreateParams = null;

export default function BankAccountCreate(
  props: NavigationProps<NavigationRoutes.BankAccountsCreate>,
) {
  const { back, navigate } = useNavigation();

  const createMutation = useCreateBankAccount();
  const permission = useGetCrudPermission('bank-accounts');

  return (
    <BankAccountForm
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);
        queryClient.refetchQueries(getBankAccountsKey());
        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.BankAccountsView, {
            id: result.data?.id,
          });
        }

        notifications.show({ message: result?.message, color: 'green' });

        return result.data;
      }}
      saveMutation={createMutation}
    />
  );
}
